import { useAuth } from '@/contexts/AuthContext'

export default function StudentHome() {
  const { profile } = useAuth()

  return (
    <div>
      <div style={{ font: '600 26px Lora, serif', color: '#1B2A4A', marginBottom: 6 }}>
        Your road-test readiness
      </div>
      <div style={{ font: '400 14px Inter, sans-serif', color: 'rgba(27,42,74,0.55)', marginBottom: 28 }}>
        Welcome, {profile?.full_name ?? 'Student'}
      </div>

      {/* Readiness score ring (placeholder) */}
      <div style={{
        display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: 16, marginBottom: 28,
      }}>
        <div style={{
          background: '#fff', border: '1px solid rgba(27,42,74,0.08)',
          borderRadius: 14, padding: '24px 22px', textAlign: 'center',
        }}>
          <div style={{ font: '700 52px Lora, serif', color: '#0F7C6C' }}>—%</div>
          <div style={{ font: '400 13px Inter, sans-serif', color: 'rgba(27,42,74,0.55)', marginTop: 6 }}>
            Readiness score
          </div>
        </div>

        <div style={{
          background: '#fff', border: '1px solid rgba(27,42,74,0.08)',
          borderRadius: 14, padding: '24px 22px',
        }}>
          <div style={{ font: '600 15px Inter, sans-serif', color: '#1B2A4A', marginBottom: 12 }}>
            Your G1 status
          </div>
          <div style={{ font: '400 13px/1.6 Inter, sans-serif', color: 'rgba(27,42,74,0.55)' }}>
            Licence number and expiry tracking will appear here once you've added your G1 details.
          </div>
        </div>
      </div>

      <div className='banner-info'>
        Student portal is ready. Course videos, skill checklist, and mock G2 test will be wired up in Phase 2.
      </div>
    </div>
  )
}
